<template>
  <el-card
    :class="['wrapper-experience-local-flex', isPpcv1 ? 'ppcv1' : '']"
    shadow="never"
  >
    <el-row>
      <el-col :span="24" class="col-text">
        <p
          ><b>{{ $t(`${base}.title`) }}</b></p
        >
        <ul class="list-benefits list-unstyled">
          <li>🤩&nbsp;{{ $t(`${base}.benefits.reservation`) }}</li>
          <li>🤑&nbsp;{{ $t(`${base}.benefits.finance`) }}</li>
          <li v-if="exExperience.can_open_date"
            >✈️&nbsp;{{ $t(`${base}.benefits.warranty`) }}</li
          >
          <li v-else
            >✈️&nbsp;{{ $t(`${base}.benefits.warranty_without_open_date`) }}</li
          >
        </ul>
      </el-col>
      <el-col :span="24" class="col-img">
        <LadImage
          src="https://cdn.localadventures.io/web-client/logos/local-flex-logo.png"
          class="img-local-flex"
          :max-width="125"
        />
        <!-- <el-button
          icon="far fa-play-circle"
          class="btn-video"
          @click="hadleOpen"
        >
        </el-button> -->
      </el-col>
    </el-row>
    <LazyHydrate never :trigger-hydration="dialog.show">
      <LadVideoDialog
        v-if="dialog.show"
        :open="dialog.show"
        :src="video"
        @close="handleClose"
      />
    </LazyHydrate>
  </el-card>
</template>

<script>
import { mapState } from 'vuex'
import { LadVideoDialog } from '@/components/pages/landing/video'

export default {
  name: 'LadMessageLocalFlex',
  components: {
    LadImage: () => import('@/components/frontends/Image'),
    LadVideoDialog,
  },
  data() {
    return {
      dialog: {
        show: false,
      },
      base: 'experience.local_flex_message',
    }
  },
  computed: {
    ...mapState('experience', {
      exExperience: (state) => ({
        can_open_date: state.experience.can_open_date,
      }),
    }),
    video() {
      const common = `https://cdn.localadventures.io/web-client/videos/localflex-{domain}.{type}`
      const domain = process.env.APP_URL.endsWith('.travel') ? 'travel' : 'mx'

      return {
        mp4: common.replace('{domain}', domain).replace('{type}', 'mp4'),
        webm: common.replace('{domain}', domain).replace('{type}', 'webm'),
        ogg: common.replace('{domain}', domain).replace('{type}', 'ogg'),
      }
    },
    isPpcv1() {
      return this.$route.params.test === 'ppcv1'
    },
  },
  methods: {
    hadleOpen() {
      // this.dialog.show = true
    },
    handleClose() {
      // this.dialog.show = false
    },
  },
}
</script>

<style lang="scss">
.wrapper-experience-local-flex {
  border: solid #3a7f18 3px !important;
  border-radius: 5px !important;
  margin-top: 0;
  margin-top: 20px;

  .ppcv1 {
    margin-top: 20px;
  }

  @media screen and (max-width: 767.98px) {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .col-text {
    width: 70%;

    @media screen and (max-width: 575.95px) {
      width: 100%;
    }

    @media (min-width: 576px) and (max-width: 767.98px) {
      width: 65%;
    }

    @media (min-width: 768px) and (max-width: 991.98px) {
      width: 60%;
    }
  }

  .col-img {
    text-align: center;
    width: 30%;
    position: relative;

    @media screen and (max-width: 575.95px) {
      width: 100%;
    }

    @media (min-width: 576px) and (max-width: 767.98px) {
      width: 35%;
    }

    @media (min-width: 768px) and (max-width: 991.98px) {
      width: 40%;
    }

    .img-local-flex {
      height: 100%;
      width: 100%;

      img {
        object-fit: cover;
        height: auto;
        width: 60%;
        max-height: 100%;

        @media screen and (max-width: 575.95px) {
          width: 45%;
          margin-top: 1rem;
        }

        @media (min-width: 576px) and (max-width: 767.98px) {
          width: 75%;
        }
      }
    }
  }

  .btn-video {
    position: absolute;
    right: 0;
    z-index: 10;
    border: none;
    font-size: 2rem;
    background-color: transparent;
    color: #000;
    bottom: 0;
    padding: 0.5rem;

    @media screen and (max-width: 575.95px) {
      right: 3rem;
    }

    &:hover {
      color: #4d4d4d;
    }
  }

  .list-benefits {
    margin: 0;

    li {
      padding: 0;
    }
  }
}
</style>
